import React from 'react';

import { Modal } from 'office-ui-fabric-react/lib/Modal';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';

export default class Loading extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      isOpened: this.props.isOpen,
      label: this.props.message
    };
  }

  loading = ( message ) => {
    this.setState({
      isOpened: true,
      label: message
    });

    return this;
  }

  finish = () => {
    this.setState({ isOpened: false })
  }

  render() {
    return (
      <Modal isOpen={ this.state.isOpened } isBlocking={ true }>
        <div className="ms-textAlignCenter" style={{ padding: '20px 100px', background: '#060d41' }}>
          <img alt="Loading" src="/assets/images/loading.jpg" />
          <Spinner size={ SpinnerSize.large } style={{ marginTop: 10, marginBottom: 10 }}/>
          <p style={{ color: 'white' }}>{ this.state.label }</p>
        </div>
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./src/component/Loading.jsx